import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  selectFieldContainer: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: 20
  },
}));
